import * as yup from 'yup';

import { FIELD_DEFINITIONS } from '../../../config';

export const MessageComposeSchema = yup.object().shape({
  to: yup
    .array(
      yup.object({
        label: yup.string(),
        value: yup.string(),
        data: yup.object(),
      }),
    )
    .min(1, 'You must select a recipient.')
    .nullable(),
  subject: yup
    .string()
    .required('A subject is required.')
    .matches(FIELD_DEFINITIONS.MATCH_NOT_BLANK_STRING, 'A subject is required.'),
  body: yup
    .string()
    .trim()
    .required('A message is required.')
    .matches(FIELD_DEFINITIONS.MATCH_NOT_BLANK_STRING, 'A message is required.'),
});

export const MessageReplySchema = yup.object().shape({
  body: yup
    .string()
    .trim()
    .required('A message is required.')
    .matches(FIELD_DEFINITIONS.MATCH_NOT_BLANK_STRING, 'A message is required.'),
});
